import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class InventuraPolozkyProvider extends BaseApi {
	async saveTable(table: any) {
		return this.update(`/${DMS_MODULE}/${NAME}`, table);
	}
}

export const apiProvider = new InventuraPolozkyProvider(DMS_MODULE, NAME);
